import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Tooltip, tokens } from '@hotjar/hotsauce';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_UNDERLINE_HEIGHT,
  HOVERED_UNDERLINE_HEIGHT,
  FILTER_MATCH_TOOLTIP_COLOR,
  UNDERLINE_COLOR,
} from './constants';
import { autoHideTooltipAfterTimeout } from '../utils/autoHideTooltip';

interface Props {
  xPositionInPx: number;
  xWidthInPx?: number;
  isRespectivePageHovered: boolean;
  showFilterMatchTooltip: boolean;
  /* Used to display the tooltip upon creation */
  showOnCreate: boolean;
}

export const UnderlineDiv = styled.div<{
  isRespectivePageHovered?: boolean;
}>`
  background: ${UNDERLINE_COLOR};
  background-clip: content-box;
  bottom: ${({ isRespectivePageHovered }) => (isRespectivePageHovered ? -4 : 2)}px;
  border-radius: 4px;
  box-shadow: 0px 0px 0px 1px ${tokens.color.text_default};
  box-shadow: none;
  cursor: pointer;
  box-sizing: border-box;
  height: ${({ isRespectivePageHovered }) =>
    isRespectivePageHovered ? HOVERED_UNDERLINE_HEIGHT : DEFAULT_UNDERLINE_HEIGHT}px;
  overflow: hidden;
  position: absolute;
  transition: all 0.1s ease-out;
  transform-origin: center;
  &:hover {
    height: ${HOVERED_UNDERLINE_HEIGHT}px;
  }
`;

export const Underline = React.memo(
  ({
    xPositionInPx,
    xWidthInPx,
    isRespectivePageHovered,
    showFilterMatchTooltip,
    showOnCreate,
  }: Props): JSX.Element | null => {
    const { t } = useTranslation();
    return (
      <>
        {Boolean(xWidthInPx && showFilterMatchTooltip) && (
          <Tooltip
            showOnCreate={showOnCreate}
            onShow={autoHideTooltipAfterTimeout}
            text={t('common:player.timeline.filter-match')}
            placement="bottom"
            css={css`
              background: ${FILTER_MATCH_TOOLTIP_COLOR};
              color: ${tokens.ALIAS_TEXT_COLORS.text_default};
              .tippy-arrow {
                color: ${FILTER_MATCH_TOOLTIP_COLOR};
              }
            `}
          >
            <UnderlineDiv
              isRespectivePageHovered={isRespectivePageHovered}
              data-testid="underline-section"
              style={{
                left: xPositionInPx,
                width: xWidthInPx,
              }}
            />
          </Tooltip>
        )}
        {!showFilterMatchTooltip && (
          <UnderlineDiv
            isRespectivePageHovered={isRespectivePageHovered}
            data-testid="underline-section"
            style={{
              left: xPositionInPx,
              width: xWidthInPx,
            }}
          />
        )}
      </>
    );
  },
);
